var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    fillRule: "nonzero",
    d: "M17.462 31.658s-.65 1.301-3.226 2.76c-.404.229-.653.657-.655 1.12v1.326c0 .714-.579 1.293-1.293 1.293h-7.76c-.715 0-1.294-.579-1.294-1.293v-.647c0-1.185-.835-2.188-1.428-3.15C.679 31.239.173 31.153.017 29.071c-.08-1.07.143-3.986.171-5.065.016-.597-.013-2.638-.036-4.514a3.331 3.331 0 0 1 3.31-3.355c1.727-.004 2.24.98 3.652 1.382.9.247 1.816.426 2.742.535.646.07 1.136.614 1.139 1.263v.114s0 2.841-3.88 2.841c-.389.097-3.235-.323-3.881-1.617"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "nonzero",
    d: "M19.163.957c-3.15.57-14.85 4.392-14.85 29.763l-.11.071a1.978 1.978 0 0 1-.323-1.073V2.587A1.94 1.94 0 0 1 5.82.647H18.11c.373 0 .74.108 1.054.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.049 2.587v27.13a1.94 1.94 0 0 1-1.94 1.94H5.82a1.932 1.932 0 0 1-1.617-.866l.11-.071c0-31.407 11.7-29.194 14.849-29.763a1.8 1.8 0 0 1 .485.453c.262.336.403.75.4 1.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464F5D",
    fillRule: "nonzero",
    d: "M18.109 32.305H5.82a2.587 2.587 0 0 1-2.587-2.587V2.587A2.587 2.587 0 0 1 5.82 0h12.288a2.587 2.587 0 0 1 2.587 2.587v27.13a2.587 2.587 0 0 1-2.587 2.588zM5.82 1.293c-.715 0-1.294.58-1.294 1.294v27.13c0 .715.58 1.294 1.294 1.294h12.288c.714 0 1.293-.58 1.293-1.293V2.587c0-.714-.579-1.294-1.293-1.294H5.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464F5D",
    fillRule: "nonzero",
    d: "M16.815.647l-.936 1.871a1.293 1.293 0 0 1-1.157.716H9.207c-.49 0-.938-.277-1.157-.716L7.114.647h9.701zM15.522 29.75H8.408a.647.647 0 1 1 0-1.294h7.114a.647.647 0 1 1 0 1.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A56A43",
    fillRule: "nonzero",
    d: "M15.522 11.641c0 .123-.007.246-.013.362l-6.94.245c.822-.693 5.012-3.161 5.478-3.802a3.884 3.884 0 0 1 1.475 3.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB8252",
    d: "M8.654 13c-.555 1.333-1.067 2-1.538 2H10l-1.346-2zM15.205 13c-.74 1.333-1.423 2-2.05 2H17l-1.795-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    fillRule: "nonzero",
    d: "M15.509 12.003c-.123 2.186-1.397 4.165-3.544 4.165-2.063 0-3.325-1.836-3.525-3.919a6.989 6.989 0 0 0 3.68-1.694l3.389 1.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4545",
    fillRule: "nonzero",
    d: "M16.815 21.213v3.363c0 .357-.29.647-.647.647H7.761a.647.647 0 0 1-.647-.647v-2.302l1.229-4.463a4.79 4.79 0 0 1 3.79-1.643 4.984 4.984 0 0 1 4.682 5.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE2F2F",
    fillRule: "nonzero",
    d: "M14.875 21.99v3.233H13.58v-3.234a.647.647 0 0 1 1.294 0zM10.348 21.99v3.233H9.054v-3.234a.647.647 0 0 1 1.294 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB8252",
    fillRule: "nonzero",
    d: "M14.047 8.446a11.928 11.928 0 0 1-1.927 2.109 6.989 6.989 0 0 1-3.68 1.694c-.02-.2-.032-.4-.032-.608 0-2.322 1.59-3.88 3.557-3.88a3.438 3.438 0 0 1 2.082.685z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F9C795",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.709 15.802l2.644-1.093a1.942 1.942 0 1 0-1.436-3.61l-1.221.486M24.576 20.017a1.94 1.94 0 0 1-1.94 1.94h-1.94a1.94 1.94 0 0 1 0-3.88h1.94a1.94 1.94 0 0 1 1.94 1.94zM23.93 23.898a1.94 1.94 0 0 1-1.94 1.94h-1.294c-.221.001-.44-.038-.647-.117a1.94 1.94 0 0 1 .647-3.764h1.293a1.94 1.94 0 0 1 1.94 1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.302 27.778a1.94 1.94 0 0 1-1.94 1.94h-.666a1.94 1.94 0 0 1 0-3.88h.666a1.94 1.94 0 0 1 1.94 1.94zM3.216 16.148c1.727-.004 2.486.97 3.898 1.37.9.248 1.816.427 2.742.536.646.07 1.136.614 1.139 1.263v.114s0 2.841-3.88 2.841c-.389.097-3.235-.323-3.881-1.617l-1.302-2.112 1.284-2.395z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 29,
    r: 7,
    fill: "#FFF",
    stroke: "#464F5D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DC4541",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 31.16l-.84.84L20 29.84 17.84 32l-.84-.84L19.16 29 17 26.84l.84-.84L20 28.16 22.16 26l.84.84L20.84 29z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorry);
export default __webpack_public_path__ + "static/media/sorry.651cbb05.svg";
export { ForwardRef as ReactComponent };